<div class="flat_file flex">
  <div>
    <button class="btn btn-primary" type="button" (click)="toggleSpace()">
      <i class="fa fa-plus" aria-hidden="true"></i>
      {{ 'AdministrationService::UploadEvents' | abpLocalization }}
    </button>
  </div>
  <div class="spaceWrapper" *ngIf="showSpace">
    <flatfile-space [spaceProps]="spaceProps"></flatfile-space>
  </div>
</div>
